// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const walrein: PokeData = {
  "id": 365,
  "name": "walrein",
  "height": 14,
  "weight": 1506,
  "base_experience": 239,
  "types": [
    PokeType.ICE,
    PokeType.WATER
  ],
  "api_moves": [
    "body-slam",
    "growl",
    "water-gun",
    "surf",
    "ice-beam",
    "blizzard",
    "aurora-beam",
    "defense-curl",
    "rest",
    "snore",
    "powder-snow",
    "rollout",
    "swagger",
    "encore",
    "crunch",
    "hail",
    "ice-ball",
    "sheer-cold",
    "water-pulse",
    "brine",
    "ice-fang",
    "liquidation"
  ],
  "moves": [
    "body-slam",
    "growl",
    "blizzard",
    "crunch",
    "sheer-cold",
    "brine",
    "ice-fang",
    "liquidation",
    "ice-wave",
    "ice-punch",
    "avalanche",
    "aurora-veil",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 187,
    "item": null,
    "species": [
      {
        "name": "spheal",
        "order": 393,
        "types": [
          PokeType.ICE,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sealeo",
        "order": 394,
        "types": [
          PokeType.ICE,
          PokeType.WATER
        ],
        "evolves_from_species_id": 363,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "walrein",
        "order": 395,
        "types": [
          PokeType.ICE,
          PokeType.WATER
        ],
        "evolves_from_species_id": 364,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 44,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 154,
    "speed": 100,
    "ability_power": 146
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
